class ShippingOptions {
	constructor(config) {
		this.config = Object.assign({
			scope: '#webshop_form',
			extra: '[data-shipping-option-extra]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this.setSelectedOption(this.$scope);
	}

	addEventListeners() {
		$(document).off('.shipping')
			.on('change.shipping', '[name=shipping-options]', (event) => this.setSelectedOption($(event.currentTarget).closest(this.config.scope)))
			.on('change.shipping', '#shipping_country', this.triggerCountryChange.bind(this));
	}

	setSelectedOption($scope) {
		let $selectedOption = $scope.find('[name=shipping-options]:checked');
		this.toggleShippingOptions($selectedOption);
	}

	toggleShippingOptions($selectedOption) {
		let target = $selectedOption.data('target');
		let $scope = $selectedOption.closest(this.config.scope);
		$scope.find(this.config.extra).css('display', 'none');

		if(!target) {
			return;
		}

		$scope.find(target).css('display', 'block');
	}

	triggerCountryChange(event) {
		this.$scope.find('select[name="country"]').trigger('change')
	}
}

export default ShippingOptions;